import Header from "./components/templates/Header.jsx";
import Main from "./components/templates/Main.jsx";
import Footer from "./components/templates/Footer.jsx";

export default function App() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}
